export const WhitelabelConstants = {
    GETWHITELABEL_REQUEST : 'GETWHITELABEL_REQUEST',
    GETWHITELABEL_SUCCESS : 'GETWHITELABEL_SUCCESS',
    GETWHITELABEL_FAILURE : 'GETWHITELABEL_FAILURE',

    CREATEWHITELABEL_REQUEST : 'CREATEWHITELABEL_REQUEST',
    CREATEWHITELABEL_SUCCESS : 'CREATEWHITELABEL_SUCCESS',
    CREATEWHITELABEL_FAILURE : 'CREATEWHITELABEL_FAILURE',

    SELECTED_WHITELABEL: 'SELECTED_WHITELABEL',
    RESET_WHITELABEL:'RESET_WHITELABEL' 
}


// WEBPACK FOOTER //
// ./src/store/constants/whitelabel.constants.js